import s from './InputField.module.css';
import { Button } from 'components/common/Button';
import { Input } from 'components/common/Input';
import { useToggle } from 'lib/hooks/useToggle';
import { InputHTMLAttributes, ReactNode, memo } from 'react';
import { ReactComponent as Eye } from 'images/openEye.svg';

const icons = {
  eye: <Eye />,
};

type InputFieldProps = {
  className?: string;
  title: string;
  value: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  action?: ReactNode;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'>;

export const InputField = memo(
  ({
    className,
    title,
    type,
    value,
    onChange,
    placeholder,
    action,
    ...props
  }: InputFieldProps) => {
    const [isVisible, setIsVisible] = useToggle(false);

    let inputType = type;
    if (type === 'password') {
      inputType = isVisible ? 'text' : 'password';
    }

    return (
      <fieldset className={s['password-field']}>
        <legend>{title}</legend>

        <div className={`${s['input-wrp']} ${className || ''}`}>
          <Input
            className={s.input}
            type={inputType}
            name={title}
            value={value}
            onChange={onChange}
            placeholder={placeholder || title}
            {...props}
          />

          {action}

          {type === 'password' && (
            <Button
              type='button'
              className={s.btn}
              data-visible={isVisible && 'visible'}
              onClick={() => setIsVisible(!isVisible)}
            >
              {icons.eye}
            </Button>
          )}
        </div>
      </fieldset>
    );
  },
);
InputField.displayName = 'InputField';
